import { forwardRef } from 'react'
import CheckIcon from '../../../components/icons/CheckIcon'
import { CheckboxContainer, CheckboxLabel, HiddenCheckbox, StyledCheckbox } from './Checkbox.styles'
import type { CheckboxProps } from './Checkbox.types'

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, checked, onChange, disabled, error, size = 'medium', ...props }, ref) => {
    return (
      <CheckboxContainer $disabled={disabled}>
        <HiddenCheckbox
          ref={ref}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          {...props}
        />
        <StyledCheckbox $checked={checked} $disabled={disabled} $error={error} $size={size}>
          <CheckIcon checked={checked} disabled={disabled} />
        </StyledCheckbox>
        {label && <CheckboxLabel $error={error}>{label}</CheckboxLabel>}
      </CheckboxContainer>
    )
  }
)

Checkbox.displayName = 'Checkbox'
